<ng-container *ngIf="showPatientSearch">
  <app-patients></app-patients>
</ng-container>